import classNames from 'clsx';
import React from 'react';
import { useDispatch } from 'react-redux';
import type { TableInstance } from 'react-table';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import type { Dispatch } from '@swf/core/store';
import { ClubPlayerStatus, PokerModalRoutes } from '@swf/core/types/Poker';
import { useIsMobileDevice } from '@swf/poker';

import styles from '../Members.scss';
import useActionButtons from '../hooks/useActionButtons';

import {
  TXTCLI_Block,
  TXTCLI_Edit,
  TXTCLI_Grant_Admin,
  TXTCLI_Reinstate,
  TXTCLI_Remove,
  TXTCLI_Suspend
} from './ActionButtons.messages.json';

const ActionButtons: React.FC<{ tableInstance: TableInstance<object> }> = ({ tableInstance }) => {
  const { disabled, handleClick } = useActionButtons({
    tableInstance,
    callbackStatuses: [ClubPlayerStatus.APPROVED, ClubPlayerStatus.SUSPENDED]
  });
  const { modal } = useDispatch<Dispatch>();
  const isMobileDevice = useIsMobileDevice();

  if (isMobileDevice) {
    return (
      <div className={classNames(styles.mobileButtons, { [styles.hidden]: disabled })}>
        <StarsButton
          translation={TXTCLI_Edit}
          onClick={() =>
            modal.enqueue({
              path: PokerModalRoutes.membersAdminActions,
              locationState: { handleClick }
            })
          }
        />
      </div>
    );
  }

  return (
    <div className={classNames(styles.actionButtons, { [styles.hidden]: disabled })}>
      <StarsButton
        className={styles.tertiaryButton}
        disabled={disabled}
        data-action="HG_REMOVE_PLAYER"
        variant="tertiary"
        size="small"
        translation={TXTCLI_Remove}
        onClick={handleClick}
      />
      <StarsButton
        className={styles.tertiaryButton}
        disabled={disabled}
        data-action="HG_MAKE_PLAYER_ADMIN"
        variant="tertiary"
        size="small"
        translation={TXTCLI_Grant_Admin}
        onClick={handleClick}
      />
      <StarsButton
        className={styles.tertiaryButton}
        disabled={disabled}
        data-action="HG_SUSPEND_PLAYER"
        variant="tertiary"
        size="small"
        translation={TXTCLI_Suspend}
        onClick={handleClick}
      />
      <StarsButton
        className={styles.tertiaryButton}
        disabled={disabled}
        data-action="HG_BLOCK_PLAYER"
        variant="tertiary"
        size="small"
        translation={TXTCLI_Block}
        onClick={handleClick}
      />
      <StarsButton
        className={styles.tertiaryButton}
        disabled={disabled}
        data-action="HG_REINSTATE_PLAYER"
        variant="tertiary"
        size="small"
        translation={TXTCLI_Reinstate}
        onClick={handleClick}
      />
    </div>
  );
};

export default ActionButtons;
